import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "loadingOverlay",
    "questionDescription",
    "input",
    "videoInput",
    "form", "uploader",
    "formSubmit",
    "uploaderError",
    "errorList",
    "previewImage",
    "photoSuccess",
    "videoSuccess"
  ]

  connect() {
    const input = this.inputTarget
    input.addEventListener('change', () => {
      this.validateMedia(input);
    })
  }

  async getVideoLength(input) {
    const file = input.files[0]
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = URL.createObjectURL(file);

    return new Promise((resolve) => {
      video.onloadedmetadata = function() {
        resolve(video.duration)
      };
    });
  }

  async validateMedia(input) {
    const errors = []
    
    if (input.accept.match(/video/)) {
      const videoLength = await this.getVideoLength(input)
      if (videoLength < input.dataset.minDuration - 3) {
        errors.push({"title": `Vidéo trop courte - ${Math.floor(videoLength)}s`, "description": `La durée de la vidéo doit être entre ${input.dataset.minDuration}s et ${input.dataset.maxDuration}s`})
      } else if (videoLength > input.dataset.maxDuration + 30) { 
        errors.push({"title": `Vidéo trop longue - ${Math.ceil(videoLength)}s`, "description": `La durée de la vidéo doit être entre ${input.dataset.minDuration}s et ${input.dataset.maxDuration}s`})
      }
    }
      
    if (errors.length) {
      this.errorListTarget.innerHTML = ""
      errors.forEach((error) => {
        this.errorListTarget.insertAdjacentHTML('beforeend', `<li class="list-group-item list-group-item-warning" style="font-size: 12px"><b class="d-block" style="font-size: 14px">${error["title"]}</b>${error["description"]}</li>`);
      })

      this.formTarget.classList.add("d-none")
      this.uploaderErrorTarget.classList.remove("d-none")
    } else {
      if (input.accept.match(/image/)) {
        const url = URL.createObjectURL(input.files[0])
        this.previewImageTarget.src = url
        this.photoSuccessTarget.classList.remove("d-none")
        this.videoSuccessTarget.classList.add("d-none")
      } else if (input.accept.match(/video/)) {
        this.photoSuccessTarget.classList.add("d-none")
        this.videoSuccessTarget.classList.remove("d-none")
      }
      this.formTarget.classList.add("d-none")
      this.uploaderTarget.classList.remove("d-none")
    }
  }

  reset() {
    this.formTarget.firstElementChild.reset()
    this.formTarget.classList.remove("d-none")
    this.uploaderTarget.classList.add("d-none")
    this.uploaderErrorTarget.classList.add("d-none")
  }

  send(piece, start, end, size, XUniqueUploadId) {
    const YOUR_CLOUD_NAME = "dpejnwyy6"
    const YOUR_UNSIGNED_UPLOAD_PRESET = "hsqysloo"
    const POST_URL = `https://api.cloudinary.com/v1_1/${YOUR_CLOUD_NAME}/auto/upload`

    const formdata = new FormData();

    formdata.append("file", piece);
    formdata.append("cloud_name", YOUR_CLOUD_NAME);
    formdata.append("upload_preset", YOUR_UNSIGNED_UPLOAD_PRESET);
    formdata.append("public_id", XUniqueUploadId);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", POST_URL, false);
    xhr.setRequestHeader("X-Unique-Upload-Id", XUniqueUploadId);
    xhr.setRequestHeader(
      "Content-Range",
      "bytes " + start + "-" + end + "/" + size
    );

    xhr.onload = function () {
      // do something to response
      const res = JSON.parse(this.responseText);
      const element = document.getElementById(`upload-progress`)
      element.innerText = `${Math.round((end / size)*93)+2}%`

      if (res.secure_url !== undefined && res.public_id !== undefined) {
        element.innerText = `${96 + _.random(0,2)}%`
        document.getElementById(`video-url`).value = res.secure_url
        document.getElementById(`video-key`).value = res.public_id
        document.getElementById(`photo-input`).remove();
        document.querySelector('[data-media-question-target="formSubmit"]').click()
      }
    };

    xhr.send(formdata);
  }

  slice(file, start, end) {
    const slice = file.mozSlice
      ? file.mozSlice
      : file.webkitSlice
      ? file.webkitSlice
      : file.slice
      ? file.slice
      : () => {};

    return slice.bind(file)(start, end);
  }

  uploadVideoToCloudinary(file) {
    const XUniqueUploadId = +new Date() + Math.random().toString(36).slice(2)

    const size = file.size
    const sliceSize = 5500000
    let start = 0
    const slice = this.slice
    const send = this.send

    setTimeout(loop, 3);

    function loop() {
      var end = start + sliceSize;

      if (end > size) {
        end = size;
      }
      var s = slice(file, start, end);
      send(s, start, end - 1, size, XUniqueUploadId);
      if (end < size) {
        start += sliceSize;
        setTimeout(loop, 3);
      }
    }
  }

  showLoading() {
    this.loadingOverlayTarget.classList.remove("d-none");
    this.loadingOverlayTarget.classList.add("d-flex");
    this.questionDescriptionTarget.classList.add("d-none");
    const element = document.getElementById(`upload-progress`)
    element.innerText = `${_.random(2,4)}%`
  }

  startUpload() {
    this.showLoading();

    const input = this.inputTarget;
    if (input.accept.match(/image/)) {
      this.formSubmitTarget.click()
    } else if (input.accept.match(/video/)) {
      setTimeout(() => {
        this.uploadVideoToCloudinary(this.inputTarget.files[0])
      }, 3)
    }
  }
}


// ASYNCHRONOUS VIDEO UPLOAD CAN BE DELETED IF NOT USED
// import { Controller } from "@hotwired/stimulus"

// export default class extends Controller {
//   static targets = [
//     "loadingOverlay",
//     "questionDescription",
//     "input",
//     "videoInput",
//     "form", "uploader",
//     "formSubmit",
//     "uploaderError",
//     "errorList",
//     "previewImage",
//     "photoSuccess",
//     "videoSuccess"
//   ]

//   connect() {
//     const input = this.inputTarget
//     input.addEventListener('change', () => {
//       this.validateMedia(input);
//     })
//   }

//   async getVideoLength(input) {
//     const file = input.files[0]
//     const video = document.createElement('video');
//     video.preload = 'metadata';
//     video.src = URL.createObjectURL(file);

//     return new Promise((resolve) => {
//       video.onloadedmetadata = function() {
//         resolve(video.duration)
//       };
//     });
//   }

//   async validateMedia(input) {
//     const errors = []
    
//     if (input.accept.match(/video/)) {
//       const videoLength = await this.getVideoLength(input)
//       if (videoLength < input.dataset.minDuration) {
//         errors.push({"title": `Vidéo trop courte - ${Math.floor(videoLength)}s`, "description": `La durée de la vidéo doit être entre ${input.dataset.minDuration}s et ${input.dataset.maxDuration}s`})
//       } else if (videoLength > input.dataset.maxDuration) { 
//         errors.push({"title": `Vidéo trop longue - ${Math.ceil(videoLength)}s`, "description": `La durée de la vidéo doit être entre ${input.dataset.minDuration}s et ${input.dataset.maxDuration}s`})
//       }
//     }
      
//     if (errors.length) {
//       this.errorListTarget.innerHTML = ""
//       errors.forEach((error) => {
//         this.errorListTarget.insertAdjacentHTML('beforeend', `<li class="list-group-item list-group-item-warning" style="font-size: 12px"><b class="d-block" style="font-size: 14px">${error["title"]}</b>${error["description"]}</li>`);
//       })

//       this.formTarget.classList.add("d-none")
//       this.uploaderErrorTarget.classList.remove("d-none")
//     } else {
//       if (input.accept.match(/image/)) {
//         const url = URL.createObjectURL(input.files[0])
//         this.previewImageTarget.src = url
//         this.photoSuccessTarget.classList.remove("d-none")
//         this.videoSuccessTarget.classList.add("d-none")
//       } else if (input.accept.match(/video/)) {
//         this.photoSuccessTarget.classList.add("d-none")
//         this.videoSuccessTarget.classList.remove("d-none")
//       }
//       this.formTarget.classList.add("d-none")
//       this.uploaderTarget.classList.remove("d-none")
//     }
//   }

//   reset() {
//     this.formTarget.firstElementChild.reset()
//     this.formTarget.classList.remove("d-none")
//     this.uploaderTarget.classList.add("d-none")
//     this.uploaderErrorTarget.classList.add("d-none")
//   }

//   asyncSend(file, start, end, size, sliceSize, XUniqueUploadId, slice, asyncSend) {
//     const YOUR_CLOUD_NAME = "dpejnwyy6"
//     const YOUR_UNSIGNED_UPLOAD_PRESET = "hsqysloo"
//     const POST_URL = `https://api.cloudinary.com/v1_1/${YOUR_CLOUD_NAME}/auto/upload`

//     end = start + sliceSize;
//     if (end > size) {
//       end = size;
//     }
//     const piece = slice(file, start, end);

//     const formdata = new FormData();

//     formdata.append("file", piece);
//     formdata.append("cloud_name", YOUR_CLOUD_NAME);
//     formdata.append("upload_preset", YOUR_UNSIGNED_UPLOAD_PRESET);
//     formdata.append("public_id", XUniqueUploadId);

//     const xhr = new XMLHttpRequest();
//     xhr.open("POST", POST_URL, true);
//     xhr.setRequestHeader("X-Unique-Upload-Id", XUniqueUploadId);
//     xhr.setRequestHeader(
//       "Content-Range",
//       "bytes " + start + "-" + (end - 1) + "/" + size
//     );

//     xhr.onload = function () {
//       // do something to response
//       const res = JSON.parse(this.responseText);
//       const element = document.getElementById(`upload-progress`)
//       element.innerText = `${Math.round((end / size)*93)+2}%`

//       if (res.secure_url !== undefined && res.public_id !== undefined) {
//         element.innerText = `${96 + _.random(0,2)}%`
//         document.getElementById(`video-url`).value = res.secure_url
//         document.getElementById(`video-key`).value = res.public_id
//         document.getElementById(`photo-input`).remove();
//         document.querySelector('[data-media-question-target="formSubmit"]').click()
//       } else {
//         start += sliceSize;
//         asyncSend(file, start, end, size, sliceSize, XUniqueUploadId, slice, asyncSend);
//       }
//     };

//     xhr.send(formdata);
//   }

//   slice(file, start, end) {
//     const slice = file.mozSlice
//       ? file.mozSlice
//       : file.webkitSlice
//       ? file.webkitSlice
//       : file.slice
//       ? file.slice
//       : () => {};

//     return slice.bind(file)(start, end);
//   }

//   uploadVideoToCloudinary(file) {
//     const XUniqueUploadId = +new Date() + Math.random().toString(36).slice(2)
//     const size = file.size
//     const sliceSize = 5500000
//     let start = 0

//     this.asyncSend(file, start, 0, size, sliceSize, XUniqueUploadId, this.slice, this.asyncSend)
//   }

//   showLoading() {
//     this.loadingOverlayTarget.classList.remove("d-none");
//     this.loadingOverlayTarget.classList.add("d-flex");
//     this.questionDescriptionTarget.classList.add("d-none");
//     const element = document.getElementById(`upload-progress`)
//     element.innerText = `${_.random(2,4)}%`
//   }

//   startUpload() {
//     this.showLoading();

//     const input = this.inputTarget;
//     if (input.accept.match(/image/)) {
//       this.formSubmitTarget.click()
//     } else if (input.accept.match(/video/)) {
//       this.uploadVideoToCloudinary(this.inputTarget.files[0])
//     }
//   }
// }